import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ActiveUserResultRow from "./ActiveUserResultRow";

const styles = (theme) => ({
  paper: {
    margin: "25px 0",
    padding: "10px 5px",
  },
});

class ActiveUserResult extends Component {
  render() {
    const { activeUsers, reasonVoid, classes } = this.props;
    return (
      <div style={{ width: "100%", minHeight: 300 }}>
        {activeUsers.length === 0 && (
          <Grid container spacing={8}>
            <Grid item sm>
              <Paper className={classes.paper}>
                <h3>{reasonVoid}</h3>
              </Paper>
            </Grid>
          </Grid>
        )}
        {activeUsers.length > 0 && (
          <Grid item sm>
            <Paper className={classes.paper}>
              <h3>Score Data</h3>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="none">Username</TableCell>
                    <TableCell padding="none">Skin</TableCell>
                    <TableCell padding="none">Ip Address</TableCell>
                    <TableCell padding="none">Started</TableCell>
                    <TableCell padding="none">Last Activity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activeUsers.map((activeUser) => (
                    <ActiveUserResultRow activeUser={activeUser} />
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        )}
      </div>
    );
  }
}

ActiveUserResult.propTypes = {
  activeUsers: PropTypes.array.isRequired,
  reasonVoid: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(ActiveUserResult);
